import React from 'react';
export function CheckIcon(props: SVGProps<SVGSVGElement>) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-130">
      <polyline points="20 6 9 17 4 12" data-id="element-131" />
    </svg>;
}